export enum UserRole {
  TRAINER = 'Trainer',
  RESTRICTED = 'Restricted',
  FULL_ACCESS = 'FullAccess',
  ORGANISATION_MANAGER = 'OrganisationManager', // this role only comes from the organisation role api
}

export interface IRole {
  id: string;
  name: UserRole;
  userId: string;
  providerId: string;
  endDateTime: string;
}
